<template>
  <div class="app-container">
    <el-form
      ref="addEditRules"
      :model="editForm"
      label-position="top"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :span="12">
          <!--流向名称-->
          <el-form-item
            :label="$t('routes.flowName')"
            prop="flowName"
            :rules="{
              required: true,
              message: this.$t('GlobalSetObj.pleaseChoose'),
              trigger: ['blur', 'change']
            }"
          >
            <el-select
              v-model="editForm.flowName"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              filterable
              style="width: 100%"
              class="formTable"
              remote
              :remote-method="getFlowDirectList"
              @change="changeFlowName"
              @visible-change="getFlowDirectList()"
            >
              <el-option
                v-for="item in flowDirectNameList"
                :key="item.id"
                :label="item.flowDirectName"
                :value="item.flowDirectName"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!--发车转运中心-->
          <el-form-item
            :label="$t('routes.departureTransferCenter')"
            prop="startTransitId"
            :rules="{
              required: true,
              message: this.$t('GlobalSetObj.pleaseChoose'),
              trigger: ['blur', 'change']
            }"
          >
            <el-select
              v-model="editForm.startTransitId"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              filterable
              style="width: 100%"
              @change="changeStartTransit"
            >
              <el-option
                v-for="item in transferList"
                :key="item.departTransferCenterId"
                :label="item.departTransferCenterName"
                :value="item.departTransferCenterId"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!--下一站流向-->
          <el-form-item
            :label="$t('routes.下一站流向')"
            prop="nextId"
            :rules="{
              required: true,
              message: this.$t('GlobalSetObj.pleaseChoose'),
              trigger: ['blur', 'change']
            }"
          >
            <el-select
              v-model="editForm.nextId"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              filterable
              style="width: 100%"
              @change="changeNextId"
            >
              <el-option
                v-for="item in flowDirectNextList"
                :key="item.nextSiteId"
                :label="item.nextSiteName"
                :value="item.nextSiteId"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!--  发车时间  -->
          <el-form-item
            :label="$t('routes.发车时间')"
            prop="departTime"
            :rules="{
              required: true,
              message: this.$t('GlobalSetObj.pleaseChoose'),
              trigger: ['blur', 'change']
            }"
          >
            <el-time-picker
              v-model="editForm.departTime"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              format="HH:mm"
              value-format="HH:mm"
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <!--  应发件时间范围  -->
          <div style="font-size: 14px;font-weight: bold;color: #696b6f;margin-bottom: 3px;">
            <span style="color: #DD4A68;margin-right: 3px">*</span>
            {{ $t('routes.DepartureTimeRange') }}
          </div>
          <el-form-item
            label=""
            prop="startDateType"
            :rules="{
              required: true,
              message: this.$t('GlobalSetObj.pleaseChoose'),
              trigger: ['blur', 'change']
            }"
            style="width: 160px;display: inline-block"
          >
            <el-select v-model="editForm.startDateType" style="width: 100%">
              <el-option :key="1" :label="$t('collectionCenter.sameDay')" :value="1" /><!--当天-->
              <el-option :key="2" :label="$t('routes.PreviousDay')" :value="0" /><!--前1天-->
            </el-select>
          </el-form-item>
          <el-form-item
            label=""
            prop="startTime"
            :rules="{
              required: true,
              validator: dateRangeRules,
              start: editForm.startTime,
              end: editForm.endTime,
              trigger: ['blur', 'change']
            }"
            style="width: 190px;display: inline-block"
          >
            <el-time-picker
              v-model="editForm.startTime"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              format="HH:mm"
              value-format="HH:mm"
            />
          </el-form-item>
          <div style="width: 10px;text-align: center;display: inline-block;margin-left: 30px;">~</div>
          <el-form-item
            label=""
            prop="endDateType"
            :rules="{
              required: true,
              message: this.$t('GlobalSetObj.pleaseChoose'),
              trigger: ['blur', 'change']
            }"
            style="width: 160px;display: inline-block"
          >
            <el-select v-model="editForm.endDateType" style="width: 100%;">
              <el-option :key="1" :label="$t('collectionCenter.sameDay')" :value="1" /><!--当天-->
            </el-select>
          </el-form-item>
          <el-form-item
            label=""
            prop="endTime"
            :rules="{
              required: true,
              validator: dateRangeRules,
              start: editForm.startTime,
              end: editForm.endTime,
              trigger: ['blur', 'change']
            }"
            style="width: 190px;display: inline-block"
          >
            <el-time-picker
              v-model="editForm.endTime"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              format="HH:mm"
              value-format="HH:mm"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import {
  addShipmentsRule,
  getTransferCenterAndNextStation,
  updateShipmentsRule
} from '@/api/managementMailingRules';
import dayjs from 'dayjs';

export default {
  name: 'Search',
  props: {
    editType: {
      type: Number,
      default: 1
    },
    editRow: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    const dateRangeRules = (rule, value, callback) => {
      console.log(rule, '====rule');
      if (value) {
        if (this.editForm.startDateType === this.editForm.endDateType) {
          const today = dayjs().format('YYYY-MM-DD'); // 获取当前日期
          const startTime = new Date(today + ' ' + this.editForm.startTime).getTime();
          const endTime = new Date(today + ' ' + this.editForm.endTime).getTime();
          if (startTime >= endTime) {
            callback(new Error(this.$t('orderCenterCont.TheStartTimeMustBeLessThanTheEndTime')));
          } else {
            callback();
          }
        } else {
          const dayBefore = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
          const today = dayjs().format('YYYY-MM-DD'); // 获取当前日期
          const startTime = new Date(dayBefore + ' ' + this.editForm.startTime).getTime();
          const endTime = new Date(today + ' ' + this.editForm.endTime).getTime();
          if ((endTime - startTime) > 86400000) {
            callback(new Error(this.$t('GlobalSetObj.TheTimeDifferenceCannotExceed24Hours')));
          } else {
            callback();
          }
        }
      } else {
        callback(new Error(this.$t('GlobalSetObj.pleaseChoose')));
      }
    };
    return {
      editForm: {
        id: '',
        flowName: '',
        startTransitId: '',
        startTransitName: '',
        nextId: '',
        nextName: '',
        departTime: '',
        startDateType: 1,
        startTime: '',
        endDateType: 1,
        endTime: ''
      },
      flowDirectNameList: [],
      transferList: [],
      flowDirectNextList: [],
      dateRangeRules
    };
  },
  watch: {
    editRow: {
      handler(val) {
        console.log(val, '===val');
        if (val) {
          this.editForm = {
            id: val.id,
            flowName: val.flowName,
            startTransitId: val.startTransitId,
            startTransitName: val.startTransitName,
            nextId: val.nextId,
            nextName: val.nextName,
            departTime: val.departTime,
            version: val.version,
            startDateType: val.startDateType,
            startTime: val.startTime,
            endDateType: val.endDateType,
            endTime: val.endTime
          };
          if (val.flowName) {
            this.transferList = [
              {
                departTransferCenterName: val.startTransitName,
                departTransferCenterId: val.startTransitId
              }
            ];
            this.getTransferList();
          }
          if (val.startTransitName) {
            this.flowDirectNextList = [
              {
                nextSiteName: val.nextName,
                nextSiteId: val.nextId
              }
            ];
            this.getFlowDirectNextList();
          }
        }
      },
      deep: true,
      immediate: true
    },
    'editForm.flowName'(val) {
      if (val) {
        this.getTransferList();
      }
    },
    'editForm.startTransitId'(val) {
      if (val) {
        this.getFlowDirectNextList();
      }
    }
  },
  created() {
    this.getFlowDirectList();
  },
  methods: {
    // 获取流向列表
    getFlowDirectList(name = '') {
      const param = {
        likeFlowDirectName: name,
        departTransferCenterId: ''
      };
      getTransferCenterAndNextStation(param).then((res) => {
        if (res.code === 200) {
          // 获取流向名称
          this.flowDirectNameList = res.data;
        }
      });
    },
    // 获取转运中心
    getTransferList() {
      const param = {
        flowDirectName: this.editForm.flowName
      };
      getTransferCenterAndNextStation(param).then((res) => {
        if (res.code === 200) {
          if (res.data && res.data.length > 0) {
            this.transferList = res.data;
            if (this.transferList.length === 1) {
              this.editForm.startTransitId = this.transferList[0].departTransferCenterId;
              this.editForm.startTransitName = this.transferList[0].departTransferCenterName;
            }
          }
        }
      });
    },
    // 获取下一站流向
    getFlowDirectNextList() {
      const param = {
        flowDirectName: this.editForm.flowName,
        departTransferCenterId: this.editForm.startTransitId
      };
      getTransferCenterAndNextStation(param).then((res) => {
        if (res.code === 200) {
          if (res.data && res.data.length > 0) {
            const flowDirectNextList = res.data.reduce((acc, item) => {
              if (item.nextSiteList && item.nextSiteList.length > 0) {
                return acc.concat(item.nextSiteList);
              }
              return acc;
            }, []);
            this.flowDirectNextList = flowDirectNextList;
            if (this.flowDirectNextList.length === 1) {
              this.editForm.nextId = this.flowDirectNextList[0].nextSiteId;
              this.editForm.nextName = this.flowDirectNextList[0].nextSiteName;
              // this.editForm.departTime = this.flowDirectNextList[0].departureTimeStr;
            }
          }
        }
      });
    },
    // 流向名称变化
    changeFlowName() {
      this.editForm.startTransitName = '';
      this.editForm.startTransitId = '';
      this.editForm.nextName = '';
      this.editForm.nextId = '';
      this.editForm.departTime = '';
      this.transferList = [];
      this.flowDirectNextList = [];
      this.getTransferList();
    },
    // 发车转运中心变化
    changeStartTransit() {
      this.editForm.nextName = '';
      this.editForm.nextId = '';
      this.editForm.departTime = '';
      this.flowDirectNextList = [];
      if (this.editForm.startTransitId) {
        this.editForm.startTransitName = this.transferList.find(item => item.departTransferCenterId === this.editForm.startTransitId).departTransferCenterName;
        // this.editForm.departTime = this.transferList.find(item => item.departTransferCenterId === this.editForm.startTransitId).departureTimeStr;
      }
      this.getFlowDirectNextList();
    },
    // 下一站流向变化
    changeNextId() {
      if (this.editForm.nextId) {
        this.editForm.nextName = this.flowDirectNextList.find(item => item.nextSiteId === this.editForm.nextId).nextSiteName;
      }
    },
    // 保存编辑
    confirmAddEdit() {
      this.$refs.addEditRules.validate(valid => {
        if (valid) {
          const param = {
            id: this.editForm.id,
            flowName: this.editForm.flowName,
            startTransitId: this.editForm.startTransitId,
            startTransitName: this.editForm.startTransitName,
            nextId: this.editForm.nextId,
            nextName: this.editForm.nextName,
            departTime: this.editForm.departTime,
            startDateType: this.editForm.startDateType,
            startTime: this.editForm.startTime,
            endDateType: this.editForm.endDateType,
            endTime: this.editForm.endTime
          };
          if (this.editType === 1) {
            addShipmentsRule(param).then(res => {
              if (res.code === 200) {
                this.$message({
                  message: this.$t('collectionCenter.addSuccessful'), // '添加成功'
                  type: 'success'
                });
                this.$emit('operateUpdate');
              }
            });
          } else {
            param.version = this.editForm.version;
            updateShipmentsRule(param).then(res => {
              if (res.code === 200) {
                this.$message({
                  message: this.$t('collectionCenter.ModificationSuccessful'), // '修改成功'
                  type: 'success'
                });
                this.$emit('operateUpdate');
              }
            });
          }
        }
      });
    }
  }
};
</script>

<style scoped>

</style>
